export const labels = {
  //Validation
  missingReferenceSheet:
    "未找到’索引_sheet’工作表。若要重试，请在新工作表中打开EY Canvas批量更新加载项。",
  descriptionError: "描述超出 {0} 个字符的上限",
  titleMissingError: "缺少标题（必填）",
  titlemaxLimitError: "标题超出 {0} 个字符的限制",
  userNotFromSelectedGroup: "请求不能同时分配给组和用户",
  dueDateFormatError: "到期日中的日期格式无效",
  fieldError:
    "无法更新EY Canvas，因为某些记录有错误。有关详细信息，请查看状态列。",
  invalidColumn: "{0} 中的数据无效",
  requiredColumn: "{0}为必填",
  hashValueMissing: "更新EY Canvas需要Hash值。检查此工作表中的列。",
  // Panel Headers
  engagement: "项目",
  select: "选择",
  numberOfRecords: "记录数量",
  dowanloadedOn: "下载时间",
  canvasUpdatesOn: "已发送至EY Canvas进行处理",
  selectRecordsToUpdate: "选择要更新的记录",
  atlasWorkpaperIndexFramework: "EY Atlas: 工作底稿索引框架",
  referenceOnly: "仅供参考",
  columnsToUpdate: "更新这些列",
  dueDateRequired: "截止日期为必填",
  requestNotAssignedError: "将请求分配给组或用户",
  infoText:
    "您不能在同一工作簿中的多个工作表上运行EY Canvas批量更新加载项。若要编辑新项目或EY Canvas项目，请在新工作簿中打开此工具。",
  noUpdatesSaved: "未保存更新",
  dummyLocalizationText: "虚拟本地化文本",
  unexpectedApiFailure: "意外的API失败。请重试。",
  titleLengthExceeded: "标题超出500个字符的上限",
  DescriptionLengthExceeded: "描述超出4000个字符的上限",
  canvasDataEditor: "Canvas数据编辑器",
  selectanitemtoedit: "请选择一个选项",
  editRequestMessage: "您要编辑哪些请求？",
  selectRequestStatus: "请至少选择一个请求状态",
  selectRequestErrorMessage: "请至少选择一个请求状态",
  sheetWithSameNameExist:
    "名为Input_sheet_ {0} 的工作表已存在。请重命名工作表以继续。",
  engagementIdNotFound:
    "未找到EY Canvas项目。请检查项目ID并确认您有权打开EY Canvas项目。",
  boundSheetAlreadyExist_1: "EY Canvas批量更新加载项",
  boundSheetAlreadyExist_2: "不适用于此标签页",
  selectAnOperation: "您想执行什么操作？",
  submit: "提交",
  next: "下一步",
  eyCanvasEngagement: "选择项目",
  search: "搜索",
  engagementNotSelected: "选择项目",
  invalidEngagement: "选择有效项目",
  back: "返回",
  noRecordsFound: "未找到记录",
  masterSheetNoteText: "注意：此工作表须使用EY Canvas批量更新加载项。",
  informationText: "您可以使用此工具：",
  infoText1: "编辑EY Canvas文档和任务名称以完成标准化索引，并",
  infoText3: "在EY Canvas中创建和编辑其他项目",
  infoTextforonlyAddClientRequest: "创建客户请求",
  yes: "是",
  no: "否",
  close: "关闭",
  ownedByEngagement: "属于本项目所有",
  sharedToEngagement: "共享到本项目",
  status: "状态",
  statusId: "状态ID",
  Continue: "继续",
  updateCanvas: "更新EY Canvas",
  newDocumentName: "新文档名称",
  documentName: "文档名称",
  fileExt: "文件扩展名",
  shared: "已共享",
  docId: "文档ID",
  hash: "Hash",
  newPrefix: "新前缀",
  newSuffix: "新后缀",
  newTitle: "新标题",
  taskPrefix: "任务前缀",
  taskSuffix: "任务后缀",
  taskTitle: "标题",
  taskType: "任务类型",
  taskTitleEditable: "可编辑任务标题",
  auditPhase: "审计阶段",
  milestone: "里程碑",
  timePhase: "时间阶段",
  taskId: "任务ID",
  populateMsg: "正在从EY Canvas填充记录",
  updatingCanvas: "正在更新EY Canvas。<br />这可能需要几分钟的时间。",
  loadingContent: "正在加载内容",
  filenameRequired: "文件名为必填项",
  excelError: "Excel公式错误。请修复并重试。",
  specialCharacters: "文档名称不能包含*/：<>\\|" + '"',
  sameDocumentNameError: "新旧文档名称相同",
  docNameLimit: "文档名称不能超过115个字符",
  markValueInvalid: '"更新EY Canvas"中存在无效值。请修复并重试。',
  docAndHashNull:
    "更新EY Canvas需要文档ID和/或Hash值。请检查此工作表中的这些列。",
  help: "帮助",
  entityNotSelected: "请选择一个选项以继续",
  AssignedToGroupInputMessageTitle: "选择组（可选）",
  AssignedToGroupInputMessageDescription:
    "若要分配给整个组，请选择一个组，并将下一列留空。",
  AssignedToUserInputMessageTitle: "选择用户（可选）",
  AssignedToUserInputMessageDescription:
    "若要分配给特定用户，请选择一个用户，并将上一列留空。用户按组列示。\\n\n注意：所有组员都将能够查看请求。如果一个用户出现在多个组中，请检查是否在下拉菜单中选择了正确的选项。",
  apiServerExceptionError:
    "连接EY Canvas时出错。请重试。如果问题仍然存在，请联系帮助台",
  taskNameExceedsLimit: "超过字符限制（标题：500个字符；前缀/后缀：50个字符）",
  taskTypeUpdateNotAllowed: "无法编辑此任务类型的任务标题",
  taskEmptyHashOrDocId:
    "更新EY Canvas需要任务ID和/或Hash值。请检查此工作表中的这些列。",
  taskTitleRequiredError: "任务标题为必填项",
  sameTaskNameError: "新旧任务名称（前缀、后缀、标题）相同",
  universalUserPreferenceGetError:
    "连接EY Canvas时用户首选项出错。请重试。如果问题仍然存在，请联系帮助台",
  sameWorkbookMultipleSessionsError:
    "不能在同一工作簿中运行多个编辑会话。若要编辑新项或EY Canvas项目，请在新工作簿中打开此工具。",
  errorMessageOnExcelUpdate:
    "无法更新EY Canvas，因为某些记录有错误。有关详细信息，请查看<b>状态</b>列。",
  insufficientPermissionsError:
    "权限不足。请检查您是否可以打开EY Canvas项目，然后重试。",
  ApiValidationErrorPreConditionFailedDocument:
    "无法更新EY Canvas。某些文档可能已被移动或删除。请在新工作簿中重新加载数据，然后重试。",
  ApiValidationFailedWithErrorDocument:
    "无法更新EY Canvas，因为某些文档有错误。有关详细信息，请查看状态列。",
  apiServerConnectError:
    "无法连接到EY Canvas。您需要连接安永内网以编辑此项目。如果问题仍然存在，请联系帮助台。",
  apiServerError:
    "连接EY Canvas时出错。请重试。如果问题仍然存在，请联系帮助台。",
  duplicateDocumentNameError: "文档名称重复",
  APIValidationError:
    "某些记录无法在EY Canvas中更新。有关详细信息，请查看<b>状态</b>列。",
  excelPopulatingMessage:
    "正在填充Excel。可能需要几分钟。在数据加载完成前，请勿点击Excel工作簿。",
  generalError: "发生错误。请重新加载EY Canvas批量更新加载项并重试。",
  boundSheetAlreadyPopulated:
    "此工作簿中已启动另一个EY Canvas批量更新加载项会话。请在新工作簿中重试。",
  excelRenderIssue:
    "点击Excel工作簿时，从EY Canvas加载数据被中断。若要重试，请在新工作簿中启动EY Canvas Excel加载项会话。",
  offlineModeLoadingMessage:
    "请打开EY Canvas Excel加载项。这可能需要几分钟的时间。正在数据加载完成前，请勿点击Excel工作簿。",
  offlineModeUserClickError:
    '您点击Excel工作表时造成打开"EY Canvas批量更新加载项"中断。若要重试，请关闭并重新打开"EY Canvas批量更新加载项"。',
  inActiveWorkbookError:
    "EY Canvas批量更新加载项出错。请打开新工作簿，然后重试。若要防止将来出现此错误，请避免在填充数据时切换工作簿。",
  clientRequestTitleMissing: "无标题（必填）",
  addclinetRequestTagError:
    "已在EY Canvas中创建了请求，但无法添加标记。您可以在EY Canvas中手动添加标记。",
  editclinetRequestTagError:
    "无法编辑此请求的标记。您可以在EY Canvas中手动添加或删除标记。",
  clinetRequestEYContactError:
    "无法为此请求编辑安永联系人。您可以在EY Canvas中手动添加或删除安永联系人。",
  forbiddenByEYError:
    "安永信息安全部禁止执行上述操作。请刷新页面并重试。如果问题仍然存在，请联系帮助台。",
  genericErrorMessage:
    "EY Canvas批量更新加载项出错。请打开新工作簿，然后重试。",
  itgcName: "IT一般控制名称（必填）",
  misstatementIndex: "Misstatement index (required)",
  misstatementDescription: "Misstatement description (required)",
  misstatementId: "Misstatement ID",
  controlName: "控制名称（必填）",
  frequency: "频率",
  designEffectiveness: "设计有效性",
  controlType: "控制类型",
  controlId: "控制ID",
  operatingEffectiveness: "运行有效性",
  testing: "测试",
  itControlId: "IT控制ID",
  isControlLowerRisk: "控制是否为较低风险？",
  timePhaseName: "Time phase name (required)",
  milestoneRequired: "里程碑 (required)",
  startDate: "Start date (YYYY-MM-DD) (required)",
  endDate: "End date (YYYY-MM-DD) (required)",
  keyEvent: "Key event",
  timePhaseId: "时间阶段ID",
  startDateFormatError: "Invalid date format in Start date",
  endDateFormatError: "Invalid date format in End date",
  deficiencyTitle: "Deficiency title (required)",
  deficiencyDescription: "Deficiency description (required)",
  deficiencyTitleOriginal: "Deficiency title",
  deficiencyDescriptionOriginal: "Deficiency description",
  deficiencyCategory: "Category",
  deficiencyId: "Deficiency ID",
  deficiencyTitleMaxLimitError: "Deficiency title exceeds 100 character limit",
  deficiencyTitleRequiredError: "Deficiency title is required",
  deficiencyDescriptionMaxLimitError:
    "Deficiency description exceeds 4000 character limit",
  deficiencyDescriptionRequiredError: "Deficiency description is required",
  invalidDeficiencyId: "Invalid Deficiency ID",
  prefix: "前缀",
  suffix: "后缀",
  requiredTitle: "标题（必填）",
  timePhaseRequired: "时间阶段（必填）",
  taskGroupRequired: "任务组（必填）",
  taskGroups: "任务组",
  customizedDescription: "定制化描述",
  customizedDescriptionRequired: "定制描述（必填）",
  picSignOffRequired: "PIC签字",
  eqrSignOffRequired: "EQR签字",
  invalidDataInTags: "标记中的数据无效",
  taskTags: "标记",
  editTaskAPIError:
    "无法编辑此任务的标记。您可以在EY Canvas中手动添加或删除标记。",
  engagementLDCVersionUpdateError:
    "安永 Canvas 批量更新加载项有可用更新。在新工作簿中加载加载项以保存任务名称的更改。",
  module: "模块",
  titleForMultiSelectInputMessage: "多选下拉框",
  descriptionForMultiSelectInputMessage:
    "使用右侧的加载窗格选择一个或多个下拉选项。",
  errorBoundaryMessage:
    "An error has occurred. Please refresh the page and try again. If the issue persists, contact the Help Desk.",
};

// export const instructionSheet={
//  headers:['#','Field Name', 'Additional instructions','To upload as Draft', 'To send to client']

//  }

export const instructionSheetHeader = {
  // reference sheet columns
  count: "#",
  fieldName: "字段名称",
  additionalInstructions: "附加说明",
  toUploadAsDraft: "以草稿状态上传",
  toSaveAsDraft: "以草稿状态保存",
  toSendToClient: "发送至客户",
  bulkUpdateAddIn: "EY Canvas批量更新加载项",
  purpose: "目的",
  guidance: "指引",
  overView: "字段概述",
  required: "必填",
};

export const instructionSheetDataForEditClient = {
  purpose: "您可以使用此工具在EY Canvas协作中批量编辑客户请求。",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "有关如何使用EY Canvas协作的更多指引，包括如何在EY Canvas协作批量编辑和发送请求，请参阅EY Atlas链接。",
  additionalInfo:
    "\u00B9 此为多选下拉字段。要编辑此字段，请使用右侧加载项窗格中的下拉菜单。",
  bulkUpdate: "\u00B2 请参阅附加说明",
};
export const instructionSheetDataForAddTaskOST = {
  purpose: "此工具可用于将新任务（其他实质性测试）批量上传到EY Canvas。",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "有关EY Canvas任务分配功能的更多指引，包括如何在EY Canvas中批量分配任务，请参阅EY Atlas链接。",
  additionalInfo:
    "\u00B9这是一个多选的下拉字段。若要编辑此字段，请使用右侧添加框上的下拉菜单。",
};
export const instructionSheetDataForEditTasks = {
  purpose: "您可以使用此工具在EY Canvas中批量编辑任务。",
  guidanceHyperlinkforStandardizedIndexing: "标准化索引",
  guidanceforStandardizedIndexing:
    "此工具可用于实现任务的标准化索引管理。有关标准化索引管理的详细信息，请参阅EY Atlas指引。",
  guidanceHyperlinkForTaskAssignments: "任务分配",
  guidanceForTaskAssignments:
    "请参阅EY Atlas链接，了解有关EY Canvas中任务分配的其他指引，包括如何在EY Canvas中批量分配任务。",
  additionalInfo:
    "\u00B9这是一个多选的下拉字段。若要编辑此字段，请使用右侧添加框上的下拉菜单。",
};
export const instructionSheetTabularDataForEditTasks = [
  {
    count: "1",
    fieldName: "更新EY Canvas",
    additionalInstructions:
      "点击加载项上的‘更新EY Canvas’按钮时：\R\n-如点击’是’，记录将包含在发送到EY Canvas的列表中\r\n-如点击'否’，记录将从发送到EY Canvas的列表中剔除",
    required: "是",
  },
  {
    count: "2",
    fieldName: "前缀",
    additionalInstructions: "使用前缀支持标准化索引的命名规则（最多50个字符）",
    required: "否",
  },
  {
    count: "3",
    fieldName: "标题",
    additionalInstructions:
      "制定一个命名约定，帮助您高效地管理任务（500个字符的限制）",
    required: "是",
  },
  {
    count: "4",
    fieldName: "后缀",
    additionalInstructions: "最多50个字符",
    required: "否",
  },
  {
    count: "5",
    fieldName: "时间阶段",
    additionalInstructions: "将任务分配到时间阶段，以支援有效的项目管理",
    required: "是",
  },
  {
    count: "6",
    fieldName: "任务组",
    additionalInstructions:
      "将工作组织成可管理的任务组。只能为其他实质性测试编辑任务组。",
    required: "是",
  },
  {
    count: "7",
    fieldName: "自定义描述",
    additionalInstructions: "描述要针对此任务执行的程序",
    required: "否",
  },
  {
    count: "8",
    fieldName: "标记\u00B9",
    additionalInstructions:
      "标记是EY Canvas中提供的自定义标签，可以帮助管理任务",
    required: "否",
  },
  {
    count: "9",
    fieldName: "PIC签字",
    additionalInstructions:
      "标注任务是否需要PIC签字。（如果从知识库中指定PIC签字，则无法编辑。）",
    required: "否",
  },
  {
    count: "10",
    fieldName: "EQR签字",
    additionalInstructions:
      "标注任务是否需要EQR签字。（如果从知识库中指定EQR签字，则无法编辑。）",
    required: "否",
  },
];

export const instructionSheetTabularDataForEditClient = [
  {
    count: "1",
    fieldName: "更新EY Canvas",
    additionalInstructions:
      '当您点击加载项上的"更新EY Canvas"按钮时：\\r\n-如点击’是’，请求将包含在发送到EY Canvas的列表中\r\n-如点击\'否’，请求将从发送到EY Canvas的列表中剔除',
    toSaveAsDraft: "是",
    toSendToClient: "不适用",
  },
  {
    count: "2",
    fieldName: "标题",
    additionalInstructions: "规定命名规则，有助于您高效管理所有请求。",
    toSaveAsDraft: "是",
    toSendToClient: "是",
  },
  {
    count: "3",
    fieldName: "描述",
    additionalInstructions: "描述的字符上限为4000",
    toSaveAsDraft: "否",
    toSendToClient: "否",
  },
  {
    count: "4",
    fieldName: "分配给（组）",
    additionalInstructions:
      "将请求分配给外部用户或组。\\r\n-若要分配给组，请从分配给（组）中选择组，并将下一列留空。\\r\n-若要分配给特定用户，请选择用户并将上一列留空。用户按组列出。\\r\n\r\n注：所有组成员都将能够查看请求。如果一个用户出现在多个组，请检查是否选择了正确的下拉选项。",
    toSaveAsDraft: "否",
    toSendToClient: "其中一项为必填",
  },
  {
    count: "5",
    fieldName: "分配给（用户）",
    additionalInstructions: "",
    toSaveAsDraft: "否",
    toSendToClient: "",
  },
  {
    count: "6",
    fieldName: "到期日（年-月-日）",
    additionalInstructions:
      "必须以年-月-日的格式指定到期日。如果未指定到期日而是选择了时间段，则到期日将默认为时间段的截止日。",
    toSaveAsDraft: "否",
    toSendToClient: "是\u00B2",
  },
  {
    count: "7",
    fieldName: "安永联系人\u00B9",
    additionalInstructions:
      "添加安永联系人，以便外部用户知晓出现问题时应联系的人员。当客户对请求作出回复时，安永联系人将收到通知。",
    toSaveAsDraft: "否",
    toSendToClient: "否",
  },
  {
    count: "8",
    fieldName: "标记\u00B9",
    additionalInstructions:
      "标记是指EY Canvas协作中提供的自定义标签，用于帮助管理请求。您可以看到项目组应用的标记和外部用户应用的标记。标记将在EY Canvas协作和EY Canvas客户端之间自动同步。",
    toSaveAsDraft: "否",
    toSendToClient: "否",
  },
  {
    count: "9",
    fieldName: "优先级",
    additionalInstructions:
      "将请求优先级设置为高或关键，以帮助客户提高请求优先级。如果未指定，则请求优先级默认为正常。",
    toSaveAsDraft: "否",
    toSendToClient: "是\u00B2",
  },
  {
    count: "10",
    fieldName: "时间阶段",
    additionalInstructions: "选择时间段和/或到期日（请参见上文）。",
    toSaveAsDraft: "否",
    toSendToClient: "否",
  },
];

export const instructionSheetData = {
  purpose:
    '此工具可用于将新的客户请求批量上传到EY Canvas协作。  请求将以"草稿"状态上传。然后，您可以从EY Canvas协作向客户批量发送请求。',
  guidanceHyperlink: "EY Atlas",
  //  guidanceHyperlink:"<a 'href=https://live.atlas.ey.com/#document/1146470?pref=20052/9/1007&crumb=11'>EY Atlas</a>",
  guidance:
    "有关如何使用EY Canvas协作的更多指引，包括如何在EY Canvas协作批量编辑和发送请求，请参阅EY Atlas链接。",
  additionalInfo: "参见附加说明",
  bulkUpdate:
    "\u00B9这是一个多选的下拉字段。若要编辑此字段，请使用右侧添加框上的下拉菜单。",
};

export const instructionSheetTabularData = [
  {
    count: "1",
    fieldName: "更新EY Canvas",
    additionalInstructions:
      '当您点击加载项上的"更新EY Canvas"按钮时：\\r\n-如点击’是’，请求将包含在发送到EY Canvas的列表中\r\n-如点击\'否’，请求将从发送到EY Canvas的列表中剔除',
    toUploadAsDraft: "是",
    toSendToClient: "不适用",
  },
  {
    count: "2",
    fieldName: "标题（必填）",
    additionalInstructions: "规定命名规则，有助于您高效管理所有请求。",
    toUploadAsDraft: "是",
    toSendToClient: "是",
  },
  {
    count: "3",
    fieldName: "描述",
    additionalInstructions: "描述的字符上限为4000",
    toUploadAsDraft: "否",
    toSendToClient: "否",
  },
  {
    count: "4",
    fieldName: "分配给（组）",
    additionalInstructions:
      "将请求分配给外部用户或组。\\r\n-若要分配给组，请从分配给（组）中选择组，并将下一列留空。\\r\n-若要分配给特定用户，请选择用户并将上一列留空。用户按组列出。\\r\n\r\n注：所有组成员都将能够查看请求。如果一个用户出现在多个组，请检查是否选择了正确的下拉选项。",
    toUploadAsDraft: "否",
    toSendToClient: "其中一项为必填",
  },
  {
    count: "5",
    fieldName: "分配给（用户）",
    additionalInstructions: "",
    toUploadAsDraft: "否",
    toSendToClient: "",
  },
  {
    count: "6",
    fieldName: "到期日（年-月-日）",
    additionalInstructions:
      "必须以年-月-日的格式指定到期日。如果未指定到期日而是选择了时间段，则到期日将默认为时间段的截止日。",
    toUploadAsDraft: "否",
    toSendToClient: "是\u00B2",
  },
  {
    count: "7",
    fieldName: "安永联系人\u00B9",
    additionalInstructions:
      "添加安永联系人，以便外部用户知晓出现问题时应联系的人员。当客户对请求作出回复时，安永联系人将收到通知。",
    toUploadAsDraft: "否",
    toSendToClient: "否",
  },
  {
    count: "8",
    fieldName: "标记\u00B9",
    additionalInstructions:
      "标记是指EY Canvas协作中提供的自定义标签，用于帮助管理请求。您可以看到项目组应用的标记和外部用户应用的标记。标记将在EY Canvas协作和EY Canvas客户端之间自动同步。",
    toUploadAsDraft: "否",
    toSendToClient: "否",
  },
  {
    count: "9",
    fieldName: "优先级",
    additionalInstructions:
      "将请求优先级设置为高或关键，以帮助客户提高请求优先级。如果未指定，则请求优先级默认为正常。",
    toUploadAsDraft: "否",
    toSendToClient: "是\u00B2",
  },
  {
    count: "10",
    fieldName: "时间阶段",
    additionalInstructions: "选择时间段和/或到期日（请参见上文）。",
    toUploadAsDraft: "否",
    toSendToClient: "否",
  },
];

export const instructionSheetStaticDataITGC = {
  purpose: "您可以使用此工具在EY Canvas中批量编辑IT一般控制详情。",
  additionalInfo:
    "\u002A如果已在EY Canvas中指定了一项值，则该值可以更改，但不能删除。",
};
export const instructionSheetStaticDataMisstatement = {
  purpose:
    "This tool can be used to bulk edit misstatement details in EY Canvas.",
  additionalInfo:
    "\u002A如果已在EY Canvas中指定了一项值，则该值可以更改，但不能删除。",
};
export const instructionSheetDataForMisstatements = {
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on misstatements and summary of audit differences.",
};
export const instructionSheetTabularDataMisstatement = [
  {
    count: "1",
    fieldName: "更新EY Canvas",
    additionalInstructions:
      "点击加载项上的‘更新EY Canvas’按钮时\R\n-如点击’是’，记录将包含在发送到EY Canvas的列表中\r\n-如点击'否’，记录将从发送到EY Canvas的列表中剔除",
    required: "是",
  },
  {
    count: "2",
    fieldName: "Misstatement index",
    additionalInstructions: "Unique identifier for the misstatement (100 character limit)",
    required: "是",
  },
  {
    count: "3",
    fieldName: "Misstatement description",
    additionalInstructions:
      "Description of the misstatement (500 character limit)\n",
    required: "是",
  },
];
export const instructionSheetStaticDataAddTaskOST = {
  purpose: "此工具可用于将新任务（其他实质性测试）批量上传到EY Canvas。",
  additionalInfo:
    "\u002A如果已在EY Canvas中指定了一项值，则该值可以更改，但不能删除。",
};
export const instructionSheetTabularDataForAddTaskOST = [
  {
    count: "1",
    fieldName: "更新EY Canvas",
    additionalInstructions:
      "点击加载项上的‘更新EY Canvas’按钮时：\R\n-如点击’是’，记录将包含在发送到EY Canvas的列表中\r\n-如点击'否’，记录将从发送到EY Canvas的列表中剔除",
    required: "是",
  },
  {
    count: "2",
    fieldName: "前缀",
    additionalInstructions: "使用前缀支持标准化索引的命名规则（最多50个字符）",
    required: "否",
  },
  {
    count: "3",
    fieldName: "标题",
    additionalInstructions:
      "制定一个命名约定，帮助您高效地管理任务（500个字符的限制）",
    required: "是",
  },
  {
    count: "4",
    fieldName: "后缀",
    additionalInstructions: "最多50个字符",
    required: "否",
  },
  {
    count: "5",
    fieldName: "时间阶段",
    additionalInstructions: "将任务分配到时间阶段，以支援有效的项目管理",
    required: "是",
  },
  {
    count: "6",
    fieldName: "任务组",
    additionalInstructions: "将工作整理成可管理的任务组",
    required: "是",
  },
  {
    count: "7",
    fieldName: "自定义描述",
    additionalInstructions: "描述要针对此任务执行的程序",
    required: "是",
  },
  {
    count: "8",
    fieldName: "标记\u00B9",
    additionalInstructions:
      "标记是EY Canvas中提供的自定义标签，可以帮助管理任务",
    required: "否",
  },
  {
    count: "9",
    fieldName: "PIC签字",
    additionalInstructions: "标注任务是否需要PIC签字",
    required: "否",
  },
  {
    count: "10",
    fieldName: "EQR签字",
    additionalInstructions: "标注任务是否需要EQR签字",
    required: "否",
  },
];
export const instructionSheetStaticDataControl = {
  purpose: "您可以使用此工具在EY Canvas中批量编辑控制详情。",
  additionalInfo:
    "\u002A如果已在EY Canvas中为此字段指定了一项值，则该值可以更改，但不能删除。",
};

export const instructionSheetStaticDataTimePhase = {
  purpose:
    "This tool can be used to bulk edit time phases details in EY Canvas.",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on the Milestones Program, which promotes effective project management and timely audit pacing. Teams can associate time phases to each milestone to plan completion of audit work by scheduled deadlines and mitigate the potential for undue compression during the year-end reporting cycle.",
};

export const instructionSheetTabularDataTimePhase = [
  {
    count: "1",
    fieldName: "更新EY Canvas",
    additionalInstructions:
      "点击加载项上的‘更新EY Canvas’按钮时：\R\n-如点击’是’，记录将包含在发送到EY Canvas的列表中\r\n-如点击'否’，记录将从发送到EY Canvas的列表中剔除",
    required: "是",
  },
  {
    count: "2",
    fieldName: "时间阶段名称",
    additionalInstructions: "500 character limit",
    required: "是",
  },
  {
    count: "3",
    fieldName: "里程碑",
    additionalInstructions: "Select a milestone from the drop-down list",
    required: "是",
  },
  {
    count: "4",
    fieldName: "开始日期",
    additionalInstructions: "Must be specified in YYYY-MM-DD format",
    required: "是",
  },
  {
    count: "5",
    fieldName: "结束日期",
    additionalInstructions: "Must be specified in YYYY-MM-DD format",
    required: "是",
  },
  {
    count: "6",
    fieldName: "Key event",
    additionalInstructions:
      "Indicate if this milestone is a key event in the completion of audit work",
    required: "否",
  },
];

export const instructionSheetTabularDataITGC = [
  {
    count: "1",
    fieldName: "更新EY Canvas",
    additionalInstructions:
      "点击加载项上的‘更新EY Canvas’按钮时：\R\n-如点击’是’，记录将包含在发送到EY Canvas的列表中\r\n-如点击'否’，记录将从发送到EY Canvas的列表中剔除",
    required: "是",
  },
  {
    count: "2",
    fieldName: "IT一般控制名称（必填）",
    additionalInstructions: "IT一般控制名称的字符上限为500",
    required: "是",
  },
  {
    count: "3",
    fieldName: "频率",
    additionalInstructions: "从下拉列表中选择控制频率",
    required: "否\u002A",
  },
  {
    count: "4",
    fieldName: "设计有效性",
    additionalInstructions:
      "如果已完成设计有效性程序，则说明结论（有效或无效）",
    required: "否",
  },
  {
    count: "5",
    fieldName: "运行有效性",
    additionalInstructions:
      "如果已完成运行有效性程序，则说明结论（有效或无效）",
    required: "否",
  },
  {
    count: "6",
    fieldName: "测试",
    additionalInstructions: "说明我们是否计划测试此控制",
    required: "否",
  },
];

export const instructionSheetTabularDataControl = [
  {
    count: "1",
    fieldName: "更新EY Canvas",
    additionalInstructions:
      "点击加载项上的‘更新EY Canvas’按钮时：\R\n-如点击’是’，记录将包含在发送到EY Canvas的列表中\r\n-如点击'否’，记录将从发送到EY Canvas的列表中剔除",
    required: "是",
  },
  {
    count: "2",
    fieldName: "控制名称（必填）",
    additionalInstructions: "控制名称的字符上限为500",
    required: "是",
  },
  {
    count: "3",
    fieldName: "频率",
    additionalInstructions: "从下拉列表中选择控制频率",
    required: "否\u002A",
  },
  {
    count: "4",
    fieldName: "控制类型",
    additionalInstructions: "从下拉列表中选择控制类型",
    required: "否\u002A",
  },
  {
    count: "5",
    fieldName: "设计有效性",
    additionalInstructions:
      "如果已完成设计有效性程序，则说明结论（有效或无效）",
    required: "否",
  },
  {
    count: "6",
    fieldName: "运行有效性",
    additionalInstructions:
      "如果已完成运行有效性程序，则说明结论（有效或无效）",
    required: "否",
  },
  {
    count: "7",
    fieldName: "测试",
    additionalInstructions: "说明我们是否计划测试此控制",
    required: "否",
  },
  {
    count: "8",
    fieldName: "控制是否为较低风险？",
    additionalInstructions: "指出控制是否风险较低",
    required: "否",
  },
];

export const errors = {
  14057: "文档名称重复",
  14084: "文档名称不能包含*/：<>\\|" + '"',
  14085: "文档名称不能超过115个字符",
  14086: "更新文档详细信息时DocService失败。",
  14088: "文档名称重复",
  5166: "无法编辑此任务类型的任务标题",
  5170: "超过字符限制（标题：500个字符；前缀/后缀：50个字符）",
  5169: "超过字符限制（标题：500个字符；前缀/后缀：50个字符）",
  5047: "超过字符限制（标题：500个字符；前缀/后缀：50个字符）",
  5018: "任务已在EY Canvas中删除或被拒绝",
  14071: "文件名为必填项",
  14054: "文件名为必填项",
  409: "文档名称重复",
  21071: "正文中发送的客户请求数超出了允许的最大限制。",
  21041: "标题超出500个字符的上限",
  21076: "优先级中的数据无效",
  21042: "描述超出4000个字符的上限",
  21072: "到期日中的数据无效",
  21027: "缺少标题（必填）",
  21039: "将请求分配给有效组/用户",
  21032: "将请求分配给有效组/用户",
  21034: "Client Group does not have active users",
  21035: "在EY Canvas中找不到请求",
  21036: "时间段中的数据无效",
  21057: '安永联系人不是项目成员、不活跃或是"仅独立性"成员',
  21073: "请求储存工具中的一个或多个数据无效。请验证数据并重试。",
  21074: "无法更改已接收请求的标题、描述或优先级",
  21075:
    "无法更改已接受请求的标题、描述、分配给（组）、分配给（用户）、截止日期、优先级或时间阶段",
  21076: "优先级类型Id枚举不包含1、2或3",
  21077: "以年年年年-月月-日日格式指定到期日期",
  21078: '更新"分配给组"或"分配给用户"时，"组"和"用户"都是必填项',
  21079: "以年年年年-月月-日日格式指定到期日期",
  21080: "当时间阶段可用时，需填入截止日期",
  21081: "安永联系人无效或包含重复联系人",
  25000: "指定时间阶段",
  26000: "以YYYY-MM-DD格式指定到期日期",
  84006: "IT一般控制名称为必填项",
  84007: "IT一般控制名称超过500字符上限",
  84008: "频率中的数据无效",
  84029: "频率中的数据无效",
  84010: "设计有效性中的数据无效",
  84027: "测试中存在无效数据",
  84028: "测试中的数据无效",
  84031: "如果测试=否，则无法就运行有效性得出结论",
  84032: "设计有效性中的数据无效",
  84004: "IT控制ID无效",
  37007: "Misstatement index is required",
  37009: "Misstatement description is required",
  37130: "Misstatement description exceeds 500 character limit",
  37036: "Invalid Misstatement ID",
  37072: "Misstatement index exceeds 100 character limit",
  83018: "控制名称超过500字符上限",
  83004: "控制ID无效",
  83006: "控制名称是必填项",
  83009: "频率中的数据无效",
  83010: "控制类型中的数据无效",
  83031: "是否为手动测试的IPE中的数据无效",
  83012: "设计有效性中的数据无效",
  83033: "运行有效性的数据无效",
  83034: "测试中的数据无效",
  85004: "Invalid Deficiency ID",
  85006: "Deficiency title is required",
  85018: "Deficiency title exceeds 100 character limit",
  85019: "Deficiency description is required",
  85042: "Deficiency description exceeds 4000 character limit",
  5169: "前缀超出50个字符的上限",
  5170: "后缀超出50个字符的上限",
  5047: "标题超出500个字符的上限",
  5108: "描述超出4000个字符的上限",
  5059: "时间阶段中的数据无效（必填）",
  5111: "任务组中的数据无效（必填）",
  5051: "任务组中的数据无效（必填）",
  5019: "自定义描述（必填）为必填",
  5103: "标题（必填）为必填",
  5104: "时间阶段（必填）为必填",
  5109: "任务组（必填）为必填",
  5203: "必須經PIC簽核",
  5204: "必須經EQR簽核",
  5202: "無法更改任務群組",
  5168: "標題（必填）為必填",
  16003: "Invalid Time phase ID",
  16006: "Invalid data in Time phase name (required)",
  16007: "Invalid data in Milestone",
  16008: "Invalid data in Start date",
  16009: "Invalid data in End date",
  16010: "Time phase name (required) is required",
  16022: "Specify a date later than 1900-01-01",
  16023: "End date must be on or after the Start date",
  16024: "Key event is required",
  16025: "Start date must be on or before the End date",
  16026: "Time phase deleted or not found in EY Canvas",
  16027: "Time phase name exceeds 500 character limit",
  16028: "Milestone (required) is required",
  16029: "Start date (YYYY-MM-DD) (required) is required",
  16030: "End date (YYYY-MM-DD) (required) is required",
};

export const milestonesLabels = {
  1: "范围",
  2: "策略",
  3: "穿行测试",
  4: "中期控制测试",
  5: "中期实质性测试",
  6: "穿行测试（年末流程）",
  7: "年末控制测试",
  8: "年末实质性测试",
  9: "结论",
  10: "不适用",
  11: "执行",
  12: "Group audit S&S",
  13: "Preliminary planning",
  14: "CRA",
  15: "Identify and assess risk",
  16: "Design response to risk",
  17: "预审后项目管理",
};

export const clientRequestStatusType = {
  1: "草稿",
  2: "草稿",
  5: "草稿",
  10: "草稿",
  11: "草稿",
  14: "草稿",
  17: "草稿",
  6: "待回复",
  9: "待回复",
  13: "待回复",
  16: "待回复",
  20: "待回复",
  21: "待回复",
  27: "待回复",
  7: "已收到",
  12: "已收到",
  15: "已收到",
  18: "已收到",
  19: "已收到",
  8: "已接受",
  28: "已接受",
};

export const filterAuditPhases = {
  1: "范围和策略",
  2: "执行",
  3: "结论",
};

export const taskTypeAbbreviation = {
  1: "TOC",
  2: "TOC",
  3: "TOC",
  4: "TOC",
  5: "TOC",
  6: "TOC",
  7: "RT",
  8: "RT",
  9: "RT",
  10: "RT",
  11: "RT",
  12: "OST",
  13: "OST",
  14: "PST",
  15: "OSP",
  16: "OSP",
  17: "PSP",
  18: "UDP",
  19: "UDP",
  20: "UDP",
  21: "UDP",
  22: "ACT",
  23: "GT",
  24: "GT",
  25: "GT",
  26: "OSP",
  27: "GT",
  28: "UDP",
  29: "EDC",
  30: "UDP",
  31: "UDP",
  32: "EDC",
  34: "RT",
};

export const uploadStatusLabels = {
  1: "待同步", //pending
  2: "已离线编辑", //offlineEdit
  3: "已下载", //downloaded
  4: "已上传", //uploaded
  5: "无效输入信息", //invalidInput
  6: "服务器错误", //serverError
  7: "API意外错误", //unexpectedAPIError
  8: "客户端获取错误", //clientFetchError
  9: "后处理错误", //postProcessingError
};

export const clientrequestRefSheetMainHeaders = {
  // reference sheet columns
  updateEyCanvas: "更新EY Canvas",
  priority: "优先级",
  assignedToGroups: "分配给（组）",
  assignedToUsers: "分配给（用户）",
  eyContacts: "安永联系人",
  tags: "标记",
  timephases: "时间段",
};

export const OstTaskReferenceSheetColumns = {
  updateEyCanvas: "更新EY Canvas",
  timePhase: "时间阶段",
  taskGroup: "任务组",
  tags: "标记",
  timephasename: "时间阶段名称",
  startDate: "开始日",
  endDate: "结束日",
  timePhaseId: "时间阶段ID",
  taskGroupName: "任务组名称",
  auditPhase: "审计阶段",
  groupName: "集团名称",
  taskGroupId: "任务组ID",
  tagDescription: "描述",
  tagGroup: "标记组",
  tagLabel: "标记",
  tagColor: "颜色",
  tagId: "标记ID",
  signOff: "签字",
  signOffValue: "签字值",
};

export const clientrequestInputSheetMainHeaders = {
  clientRequestTitle: "标题（必填）",
  clientRequestDescription: "描述",
  AssignedToGroup: "分配至（组）",
  AssignedToUser: "分配至（用户）",
  DueDate: "到期日（年月日）",
  eyContact: "安永联系人",
  tags: "标记",
  priority: "优先级",
  requestGuid: "客户请求GUID",
  requestId: "客户请求ID",
  statusID: "状态ID",
  timephases: "时间段",
  requestHash: "请求#",
  requestHashSpace: "请求#",
  clientRequestTitleSpace: "标题（必填）",
  clientRequestDescriptionSpace: "描述",
  AssignedToGroupSpace: "分配给（组）",
  AssignedToUserSpace: "分配给（用户）",
  DueDateSpace: "到期日（年-月-日）",
  eyContactSpace: "安永联系人",
  tagsSpace: "标记",
  prioritySpace: "优先级",
  timephasesSpace: "时间段",
  requestStatusId: "请求状态ID",
  requestStatus: "请求状态",
};

export const clientrequestRefSheetSubHeaders = {
  priority: {
    priorityName: "优先级名称",
    priorityTypeId: "优先级类型ID",
  },
  assignedToGroups: {
    group: "分组",
    groupName: "集团名称",
    groupId: "小组ID",
  },
  assignedToUsers: {
    groupMember: "小组成员",
    name: "名称",
    groupName: "集团名称",
    userId: "用户ID",
    groupId: "小组ID",
  },
  eyContacts: {
    name: "名称",
    userId: "用户ID",
  },
  tags: {
    tagName: "标签",
    colorCode: "颜色",
    engagementTagName: "描述",
    engagementTagID: "标签ID",
  },
  timephases: {
    timePhaseName: "时间阶段",
    periodName: "时间阶段名称",
    startDate: "开始日",
    dueDate: "结束日期",
    timephaseId: "时间段ID",
  },
};

export const priorityTypesCollaboration = [
  {
    value: 1,
    label: "正常",
  },
  {
    value: 3,
    label: "高",
  },
  {
    value: 4,
    label: "严重",
  },
];

export const ButtonOptions = [
  {
    label: "编辑文档名称",
    activeButton: "active-btn",
    id: 1,
    DisplayOrder: 4,
  },
  {
    label: "创建客户请求草稿",
    activeButton: "active-btn",
    id: 3,
    DisplayOrder: 1,
  },
  {
    label: "编辑客户请求",
    activeButton: "active-btn",
    id: 4,
    DisplayOrder: 2,
  },
  {
    label: "编辑IT一般控制",
    activeButton: "active-btn",
    id: 5,
    DisplayOrder: 5,
  },
  {
    label: "编辑任务",
    activeButton: "active-btn",
    id: 2,
    DisplayOrder: 8,
  },
  {
    label: "Edit time phases",
    activeButton: "active-btn",
    id: 8,
    DisplayOrder: 9,
  },
  {
    label: "编辑控制",
    activeButton: "active-btn",
    id: 6,
    DisplayOrder: 3,
  },
  {
    label: "创建任务（其他实质性测试）",
    activeButton: "active-btn",
    id: 7,
    DisplayOrder: 7,
  },
  {
    label: "Edit misstatements",
    activeButton: "active-btn",
    id: 9,
    DisplayOrder: 6,
  },
  {
    label: "Edit deficiencies",
    activeButton: "active-btn",
    id: 10,
    DisplayOrder: 10,
  },
];

export const ClientRequestTypeOptions = [
  {
    label: "草稿",
    id: 1,
    apiPayload: "Draft",
  },
  {
    label: "待回复",
    id: 2,
    apiPayload: "Pending",
  },
  {
    label: "已收到",
    id: 3,
    apiPayload: "Received",
  },
  {
    label: "已接受",
    id: 4,
    apiPayload: "Accepted",
  },
];

export const colorOptionsLabels = [
  {
    value: "红色",
    label: "红色",
  },
  {
    value: "橙色",
    label: "橙色",
  },
  {
    value: "青色",
    label: "青色",
  },
  {
    value: "蓝色",
    label: "蓝色",
  },
  {
    value: "紫色",
    label: "紫色",
  },
  {
    value: "绿色",
    label: "绿色",
  },
  {
    value: "黄色",
    label: "黄色",
  },
  {
    value: "灰色",
    label: "灰色",
  },
];

export const controlFrequencyNameTypes = [
  {
    id: 1,
    value: 1,
    label: "每日多次",
  },
  {
    id: 2,
    value: 2,
    label: "每日",
  },
  {
    id: 3,
    value: 3,
    label: "每周",
  },
  {
    id: 4,
    value: 4,
    label: "每月",
  },
  {
    id: 5,
    value: 5,
    label: "每季度",
  },
  {
    id: 6,
    value: 6,
    label: "每年",
  },
  {
    id: 8,
    value: 8,
    label: "其他",
  },
];

export const controlDesignEffectivenessType = [
  {
    id: 1,
    value: 1,
    label: "有效",
  },
  {
    id: 2,
    value: 2,
    label: "无效",
  },
];

export const operativeEffectivenessType = [
  {
    id: true,
    value: true,
    label: "有效",
  },
  {
    id: false,
    value: false,
    label: "无效",
  },
];

export const BooleanType = [
  {
    id: true,
    value: true,
    label: "true",
  },
  {
    id: false,
    value: false,
    label: "错误",
  },
];

export const YesNoTypes = [
  {
    id: true,
    value: 1,
    booleanValue: true,
    label: "是",
  },
  {
    id: false,
    value: 0,
    booleanValue: false,
    label: "否",
  },
];

export const controlTypes = [
  {
    id: 1,
    value: 1,
    label: "IT应用程序控制",
  },
  {
    id: 2,
    value: 2,
    label: "依赖IT的手动控制",
  },
  {
    id: 3,
    value: 3,
    label: "手动预防",
  },
  {
    id: 4,
    value: 4,
    label: "手动发现",
  },
];

// Mirrors filterMilestones in EY Canvas web: ordered the way EY Canvas displays milestones rather than by id,
// omitting Scope (1), Strategy (2) and "No milestone" (0) because EY Canvas hides those from this dropdown.
export const timephaseTypes = [
  {
    id: 12,
    value: 12,
    label: "Group audit S&S",
  },
  {
    id: 13,
    value: 13,
    label: "Preliminary planning",
  },
  {
    id: 14,
    value: 14,
    label: "CRA",
  },
  {
    id: 15,
    value: 15,
    label: "Identify and assess risk",
  },
  {
    id: 16,
    value: 16,
    label: "Design response to risk",
  },
  {
    id: 17,
    value: 17,
    label: "预审后项目管理",
  },
  {
    id: 3,
    value: 3,
    label: "穿行测试",
  },
  {
    id: 4,
    value: 4,
    label: "中期控制测试",
  },
  {
    id: 5,
    value: 5,
    label: "中期实质性测试",
  },
  {
    id: 6,
    value: 6,
    label: "穿行测试（年末流程）",
  },
  {
    id: 7,
    value: 7,
    label: "年末控制测试",
  },
  {
    id: 8,
    value: 8,
    label: "年末实质性测试",
  },
  {
    id: 11,
    value: 11,
    label: "执行",
  },
  {
    id: 9,
    value: 9,
    label: "结论",
  },
  {
    id: 10,
    value: 10,
    label: "不适用",
  },
];

export const deficiencyCategoryTypes = [
  {
    id: 19,
    value: 19,
    label: "Business process",
  },
  {
    id: 34,
    value: 34,
    label: "IT process",
  },
];
